import { initialiseScrollAnimationTrigger } from "./scripts/scroll/scroll-animations"
import { InitScrollToTop } from "./scripts/scroll/scroll-to-top"
import { Tab } from "./scripts/shared/tabs"
import { Modal } from "./scripts/shared/modal"
import { InitMobileMenu } from "./scripts/shared/mobile-menu"

document.addEventListener('DOMContentLoaded', () => { 
    document.body.classList.remove('no-js')
    document.body.classList.add('js')

    initialiseScrollAnimationTrigger()
    InitScrollToTop()
    InitMobileMenu()

    document.body.addEventListener('click', (event) => {
        const button = event.target.closest('.floorplan-toggle');
        if (!button) return;
    
        const card = button.closest('.block--property-card');
        if (!card) return;
    
        toggleFloorPlanOnCard(card, button);
    });

    document.querySelectorAll('.js-tabs').forEach(tabElement => {
        const tabs = new Tab(tabElement);
        // tabs.init?.(); // optional, if you're using an explicit init() method
    });

    const modalElements = document.querySelectorAll('.js-modal');
    const activeModals = []; // Keep track of active modal instances
  
    modalElements.forEach((modalEl) => {
        activeModals.push(new Modal(modalEl));
    });
    
})

function toggleFloorPlanOnCard(card, button) {
    const floorplanId = button.getAttribute('data-floorplan-id');
  
    // Set active floorplan ID on card
    card.dataset.activeFloorplanId = floorplanId;
  
    // Toggle floorplan detail visibility
    card.querySelectorAll('.property-details').forEach(detail => {
        detail.classList.toggle('visible', detail.dataset.floorplanId === floorplanId);
    });
  
    // Toggle active state on buttons
    card.querySelectorAll('.floorplan-toggle').forEach(btn => {
        btn.classList.toggle('active', btn === button);
    });
  
    // Show/hide matching "Add to Compare" buttons
    card.querySelectorAll('.add-to-compare').forEach(compareButton => {
        const comparePropertyId = compareButton.dataset.id;
        compareButton.classList.toggle('visible', comparePropertyId === floorplanId);
    });
}